/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AppDomainBalanceSchemasBulkOperationResponse,
  BalanceAdjustmentRequest,
  BalanceCheckRequest,
  BalanceCheckResponse,
  BalanceDeductionRequest,
  BalanceListResponse,
  BalanceOperationResponse,
  BulkBalanceResetRequest,
  GetMyBalanceHistoryParams,
  GetMyTransactionsParams,
  GetUserBalanceParams,
  HTTPValidationError,
  ResetUserAnnualBalanceParams,
  SearchBalancesParams,
  SearchTransactionsParams,
  TransactionListResponse,
  UserBalanceCreate,
  UserBalanceResponse,
  UserBalanceSummary
} from '../model';

import { apiInstance } from '../../lib/apiInstance';




/**
 * Get current user's balance for the current year. Returns balance with 0 credit if no matching contracts found.
 * @summary Get My Current Balance
 */
export const getMyCurrentBalance = (

 signal?: AbortSignal
) => {


      return apiInstance<UserBalanceResponse>(
      {url: `/api/balance/my-balance`, method: 'GET', signal
    },
      );
    }




export const getGetMyCurrentBalanceQueryKey = () => {
    return [
    `/api/balance/my-balance`
    ] as const;
    }


export const getGetMyCurrentBalanceQueryOptions = <TData = Awaited<ReturnType<typeof getMyCurrentBalance>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyCurrentBalance>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyCurrentBalanceQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyCurrentBalance>>> = ({ signal }) => getMyCurrentBalance(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyCurrentBalance>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyCurrentBalanceQueryResult = NonNullable<Awaited<ReturnType<typeof getMyCurrentBalance>>>
export type GetMyCurrentBalanceQueryError = unknown


export function useGetMyCurrentBalance<TData = Awaited<ReturnType<typeof getMyCurrentBalance>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyCurrentBalance>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyCurrentBalance>>,
          TError,
          Awaited<ReturnType<typeof getMyCurrentBalance>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyCurrentBalance<TData = Awaited<ReturnType<typeof getMyCurrentBalance>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyCurrentBalance>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyCurrentBalance>>,
          TError,
          Awaited<ReturnType<typeof getMyCurrentBalance>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyCurrentBalance<TData = Awaited<ReturnType<typeof getMyCurrentBalance>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyCurrentBalance>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get My Current Balance
 */

export function useGetMyCurrentBalance<TData = Awaited<ReturnType<typeof getMyCurrentBalance>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyCurrentBalance>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyCurrentBalanceQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Get comprehensive balance summary for current user
 * @summary Get My Balance Summary
 */
export const getMyBalanceSummary = (

 signal?: AbortSignal
) => {


      return apiInstance<UserBalanceSummary>(
      {url: `/api/balance/my-balance/summary`, method: 'GET', signal
    },
      );
    }




export const getGetMyBalanceSummaryQueryKey = () => {
    return [
    `/api/balance/my-balance/summary`
    ] as const;
    }


export const getGetMyBalanceSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getMyBalanceSummary>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyBalanceSummary>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyBalanceSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyBalanceSummary>>> = ({ signal }) => getMyBalanceSummary(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyBalanceSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyBalanceSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getMyBalanceSummary>>>
export type GetMyBalanceSummaryQueryError = unknown


export function useGetMyBalanceSummary<TData = Awaited<ReturnType<typeof getMyBalanceSummary>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyBalanceSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyBalanceSummary>>,
          TError,
          Awaited<ReturnType<typeof getMyBalanceSummary>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyBalanceSummary<TData = Awaited<ReturnType<typeof getMyBalanceSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyBalanceSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyBalanceSummary>>,
          TError,
          Awaited<ReturnType<typeof getMyBalanceSummary>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyBalanceSummary<TData = Awaited<ReturnType<typeof getMyBalanceSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyBalanceSummary>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get My Balance Summary
 */

export function useGetMyBalanceSummary<TData = Awaited<ReturnType<typeof getMyBalanceSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyBalanceSummary>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyBalanceSummaryQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Get current user's balance history
 * @summary Get My Balance History
 */
export const getMyBalanceHistory = (
    params?: GetMyBalanceHistoryParams,
 signal?: AbortSignal
) => {


      return apiInstance<UserBalanceResponse[]>(
      {url: `/api/balance/my-balance/history`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetMyBalanceHistoryQueryKey = (params?: GetMyBalanceHistoryParams,) => {
    return [
    `/api/balance/my-balance/history`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMyBalanceHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getMyBalanceHistory>>, TError = HTTPValidationError>(params?: GetMyBalanceHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyBalanceHistory>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyBalanceHistoryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyBalanceHistory>>> = ({ signal }) => getMyBalanceHistory(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyBalanceHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyBalanceHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getMyBalanceHistory>>>
export type GetMyBalanceHistoryQueryError = HTTPValidationError


export function useGetMyBalanceHistory<TData = Awaited<ReturnType<typeof getMyBalanceHistory>>, TError = HTTPValidationError>(
 params: undefined |  GetMyBalanceHistoryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyBalanceHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyBalanceHistory>>,
          TError,
          Awaited<ReturnType<typeof getMyBalanceHistory>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyBalanceHistory<TData = Awaited<ReturnType<typeof getMyBalanceHistory>>, TError = HTTPValidationError>(
 params?: GetMyBalanceHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyBalanceHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyBalanceHistory>>,
          TError,
          Awaited<ReturnType<typeof getMyBalanceHistory>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyBalanceHistory<TData = Awaited<ReturnType<typeof getMyBalanceHistory>>, TError = HTTPValidationError>(
 params?: GetMyBalanceHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyBalanceHistory>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get My Balance History
 */

export function useGetMyBalanceHistory<TData = Awaited<ReturnType<typeof getMyBalanceHistory>>, TError = HTTPValidationError>(
 params?: GetMyBalanceHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyBalanceHistory>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyBalanceHistoryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Get current user's transaction history
 * @summary Get My Transactions
 */
export const getMyTransactions = (
    params?: GetMyTransactionsParams,
 signal?: AbortSignal
) => {


      return apiInstance<TransactionListResponse>(
      {url: `/api/balance/my-transactions`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetMyTransactionsQueryKey = (params?: GetMyTransactionsParams,) => {
    return [
    `/api/balance/my-transactions`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMyTransactionsQueryOptions = <TData = Awaited<ReturnType<typeof getMyTransactions>>, TError = HTTPValidationError>(params?: GetMyTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyTransactions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyTransactionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyTransactions>>> = ({ signal }) => getMyTransactions(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyTransactions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof getMyTransactions>>>
export type GetMyTransactionsQueryError = HTTPValidationError


export function useGetMyTransactions<TData = Awaited<ReturnType<typeof getMyTransactions>>, TError = HTTPValidationError>(
 params: undefined |  GetMyTransactionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyTransactions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyTransactions>>,
          TError,
          Awaited<ReturnType<typeof getMyTransactions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyTransactions<TData = Awaited<ReturnType<typeof getMyTransactions>>, TError = HTTPValidationError>(
 params?: GetMyTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyTransactions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyTransactions>>,
          TError,
          Awaited<ReturnType<typeof getMyTransactions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyTransactions<TData = Awaited<ReturnType<typeof getMyTransactions>>, TError = HTTPValidationError>(
 params?: GetMyTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyTransactions>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get My Transactions
 */

export function useGetMyTransactions<TData = Awaited<ReturnType<typeof getMyTransactions>>, TError = HTTPValidationError>(
 params?: GetMyTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyTransactions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyTransactionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Check if user has sufficient balance for a purchase (users can only check their own balance)
 * @summary Check Balance Sufficiency
 */
export const checkBalanceSufficiency = (
    balanceCheckRequest: BalanceCheckRequest,
 signal?: AbortSignal
) => {


      return apiInstance<BalanceCheckResponse>(
      {url: `/api/balance/check`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: balanceCheckRequest, signal
    },
      );
    }



export const getCheckBalanceSufficiencyMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkBalanceSufficiency>>, TError,{data: BalanceCheckRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof checkBalanceSufficiency>>, TError,{data: BalanceCheckRequest}, TContext> => {

const mutationKey = ['checkBalanceSufficiency'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkBalanceSufficiency>>, {data: BalanceCheckRequest}> = (props) => {
          const {data} = props ?? {};

          return  checkBalanceSufficiency(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CheckBalanceSufficiencyMutationResult = NonNullable<Awaited<ReturnType<typeof checkBalanceSufficiency>>>
    export type CheckBalanceSufficiencyMutationBody = BalanceCheckRequest
    export type CheckBalanceSufficiencyMutationError = HTTPValidationError

    /**
 * @summary Check Balance Sufficiency
 */
export const useCheckBalanceSufficiency = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkBalanceSufficiency>>, TError,{data: BalanceCheckRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof checkBalanceSufficiency>>,
        TError,
        {data: BalanceCheckRequest},
        TContext
      > => {
      return useMutation(getCheckBalanceSufficiencyMutationOptions(options), queryClient);
    }
    /**
 * Get balance for a specific user and year (Admin only)
 * @summary Get User Balance
 */
export const getUserBalance = (
    userId: string,
    params?: GetUserBalanceParams,
 signal?: AbortSignal
) => {


      return apiInstance<UserBalanceResponse>(
      {url: `/api/balance/users/${userId}`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetUserBalanceQueryKey = (userId: string,
    params?: GetUserBalanceParams,) => {
    return [
    `/api/balance/users/${userId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetUserBalanceQueryOptions = <TData = Awaited<ReturnType<typeof getUserBalance>>, TError = HTTPValidationError>(userId: string,
    params?: GetUserBalanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserBalance>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserBalanceQueryKey(userId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserBalance>>> = ({ signal }) => getUserBalance(userId,params, signal);





   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserBalance>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserBalanceQueryResult = NonNullable<Awaited<ReturnType<typeof getUserBalance>>>
export type GetUserBalanceQueryError = HTTPValidationError


export function useGetUserBalance<TData = Awaited<ReturnType<typeof getUserBalance>>, TError = HTTPValidationError>(
 userId: string,
    params: undefined |  GetUserBalanceParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserBalance>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserBalance>>,
          TError,
          Awaited<ReturnType<typeof getUserBalance>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserBalance<TData = Awaited<ReturnType<typeof getUserBalance>>, TError = HTTPValidationError>(
 userId: string,
    params?: GetUserBalanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserBalance>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserBalance>>,
          TError,
          Awaited<ReturnType<typeof getUserBalance>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserBalance<TData = Awaited<ReturnType<typeof getUserBalance>>, TError = HTTPValidationError>(
 userId: string,
    params?: GetUserBalanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserBalance>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get User Balance
 */

export function useGetUserBalance<TData = Awaited<ReturnType<typeof getUserBalance>>, TError = HTTPValidationError>(
 userId: string,
    params?: GetUserBalanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserBalance>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserBalanceQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Get comprehensive balance summary for a specific user (Admin only)
 * @summary Get User Balance Summary
 */
export const getUserBalanceSummary = (
    userId: string,
 signal?: AbortSignal
) => {


      return apiInstance<UserBalanceSummary>(
      {url: `/api/balance/users/${userId}/summary`, method: 'GET', signal
    },
      );
    }




export const getGetUserBalanceSummaryQueryKey = (userId: string,) => {
    return [
    `/api/balance/users/${userId}/summary`
    ] as const;
    }


export const getGetUserBalanceSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getUserBalanceSummary>>, TError = HTTPValidationError>(userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserBalanceSummary>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserBalanceSummaryQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserBalanceSummary>>> = ({ signal }) => getUserBalanceSummary(userId, signal);





   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserBalanceSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserBalanceSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getUserBalanceSummary>>>
export type GetUserBalanceSummaryQueryError = HTTPValidationError


export function useGetUserBalanceSummary<TData = Awaited<ReturnType<typeof getUserBalanceSummary>>, TError = HTTPValidationError>(
 userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserBalanceSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserBalanceSummary>>,
          TError,
          Awaited<ReturnType<typeof getUserBalanceSummary>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserBalanceSummary<TData = Awaited<ReturnType<typeof getUserBalanceSummary>>, TError = HTTPValidationError>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserBalanceSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserBalanceSummary>>,
          TError,
          Awaited<ReturnType<typeof getUserBalanceSummary>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserBalanceSummary<TData = Awaited<ReturnType<typeof getUserBalanceSummary>>, TError = HTTPValidationError>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserBalanceSummary>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get User Balance Summary
 */

export function useGetUserBalanceSummary<TData = Awaited<ReturnType<typeof getUserBalanceSummary>>, TError = HTTPValidationError>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserBalanceSummary>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserBalanceSummaryQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Create a new balance for a user (Admin only)
 * @summary Create User Balance
 */
export const createUserBalance = (
    userId: string,
    userBalanceCreate: UserBalanceCreate,
 signal?: AbortSignal
) => {


      return apiInstance<UserBalanceResponse>(
      {url: `/api/balance/users/${userId}/create`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userBalanceCreate, signal
    },
      );
    }



export const getCreateUserBalanceMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserBalance>>, TError,{userId: string;data: UserBalanceCreate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createUserBalance>>, TError,{userId: string;data: UserBalanceCreate}, TContext> => {

const mutationKey = ['createUserBalance'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUserBalance>>, {userId: string;data: UserBalanceCreate}> = (props) => {
          const {userId,data} = props ?? {};

          return  createUserBalance(userId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateUserBalanceMutationResult = NonNullable<Awaited<ReturnType<typeof createUserBalance>>>
    export type CreateUserBalanceMutationBody = UserBalanceCreate
    export type CreateUserBalanceMutationError = HTTPValidationError

    /**
 * @summary Create User Balance
 */
export const useCreateUserBalance = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserBalance>>, TError,{userId: string;data: UserBalanceCreate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createUserBalance>>,
        TError,
        {userId: string;data: UserBalanceCreate},
        TContext
      > => {
      return useMutation(getCreateUserBalanceMutationOptions(options), queryClient);
    }
    /**
 * Deduct amount from user's balance (Admin only)
 * @summary Deduct Balance
 */
export const deductBalance = (
    balanceDeductionRequest: BalanceDeductionRequest,
 signal?: AbortSignal
) => {


      return apiInstance<BalanceOperationResponse>(
      {url: `/api/balance/deduct`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: balanceDeductionRequest, signal
    },
      );
    }



export const getDeductBalanceMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deductBalance>>, TError,{data: BalanceDeductionRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deductBalance>>, TError,{data: BalanceDeductionRequest}, TContext> => {

const mutationKey = ['deductBalance'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deductBalance>>, {data: BalanceDeductionRequest}> = (props) => {
          const {data} = props ?? {};

          return  deductBalance(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeductBalanceMutationResult = NonNullable<Awaited<ReturnType<typeof deductBalance>>>
    export type DeductBalanceMutationBody = BalanceDeductionRequest
    export type DeductBalanceMutationError = HTTPValidationError

    /**
 * @summary Deduct Balance
 */
export const useDeductBalance = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deductBalance>>, TError,{data: BalanceDeductionRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deductBalance>>,
        TError,
        {data: BalanceDeductionRequest},
        TContext
      > => {
      return useMutation(getDeductBalanceMutationOptions(options), queryClient);
    }
    /**
 * Adjust user's balance (Admin only)
 * @summary Adjust Balance
 */
export const adjustBalance = (
    balanceAdjustmentRequest: BalanceAdjustmentRequest,
 signal?: AbortSignal
) => {


      return apiInstance<BalanceOperationResponse>(
      {url: `/api/balance/adjust`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: balanceAdjustmentRequest, signal
    },
      );
    }



export const getAdjustBalanceMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adjustBalance>>, TError,{data: BalanceAdjustmentRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adjustBalance>>, TError,{data: BalanceAdjustmentRequest}, TContext> => {

const mutationKey = ['adjustBalance'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adjustBalance>>, {data: BalanceAdjustmentRequest}> = (props) => {
          const {data} = props ?? {};

          return  adjustBalance(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdjustBalanceMutationResult = NonNullable<Awaited<ReturnType<typeof adjustBalance>>>
    export type AdjustBalanceMutationBody = BalanceAdjustmentRequest
    export type AdjustBalanceMutationError = HTTPValidationError

    /**
 * @summary Adjust Balance
 */
export const useAdjustBalance = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adjustBalance>>, TError,{data: BalanceAdjustmentRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adjustBalance>>,
        TError,
        {data: BalanceAdjustmentRequest},
        TContext
      > => {
      return useMutation(getAdjustBalanceMutationOptions(options), queryClient);
    }
    /**
 * Reset specific user's balance for a given year (Admin only)
 * @summary Reset User Annual Balance
 */
export const resetUserAnnualBalance = (
    userId: string,
    year: number,
    params?: ResetUserAnnualBalanceParams,
 signal?: AbortSignal
) => {


      return apiInstance<BalanceOperationResponse>(
      {url: `/api/balance/reset/${userId}/${year}`, method: 'POST',
        params, signal
    },
      );
    }



export const getResetUserAnnualBalanceMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetUserAnnualBalance>>, TError,{userId: string;year: number;params?: ResetUserAnnualBalanceParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof resetUserAnnualBalance>>, TError,{userId: string;year: number;params?: ResetUserAnnualBalanceParams}, TContext> => {

const mutationKey = ['resetUserAnnualBalance'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetUserAnnualBalance>>, {userId: string;year: number;params?: ResetUserAnnualBalanceParams}> = (props) => {
          const {userId,year,params} = props ?? {};

          return  resetUserAnnualBalance(userId,year,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetUserAnnualBalanceMutationResult = NonNullable<Awaited<ReturnType<typeof resetUserAnnualBalance>>>

    export type ResetUserAnnualBalanceMutationError = HTTPValidationError

    /**
 * @summary Reset User Annual Balance
 */
export const useResetUserAnnualBalance = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetUserAnnualBalance>>, TError,{userId: string;year: number;params?: ResetUserAnnualBalanceParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetUserAnnualBalance>>,
        TError,
        {userId: string;year: number;params?: ResetUserAnnualBalanceParams},
        TContext
      > => {
      return useMutation(getResetUserAnnualBalanceMutationOptions(options), queryClient);
    }
    /**
 * Bulk reset balances for all users or specified users for a given year (Admin only)
 * @summary Bulk Reset Annual Balances
 */
export const bulkResetAnnualBalances = (
    bulkBalanceResetRequest: BulkBalanceResetRequest,
 signal?: AbortSignal
) => {


      return apiInstance<AppDomainBalanceSchemasBulkOperationResponse>(
      {url: `/api/balance/bulk-reset`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkBalanceResetRequest, signal
    },
      );
    }



export const getBulkResetAnnualBalancesMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkResetAnnualBalances>>, TError,{data: BulkBalanceResetRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof bulkResetAnnualBalances>>, TError,{data: BulkBalanceResetRequest}, TContext> => {

const mutationKey = ['bulkResetAnnualBalances'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkResetAnnualBalances>>, {data: BulkBalanceResetRequest}> = (props) => {
          const {data} = props ?? {};

          return  bulkResetAnnualBalances(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkResetAnnualBalancesMutationResult = NonNullable<Awaited<ReturnType<typeof bulkResetAnnualBalances>>>
    export type BulkResetAnnualBalancesMutationBody = BulkBalanceResetRequest
    export type BulkResetAnnualBalancesMutationError = HTTPValidationError

    /**
 * @summary Bulk Reset Annual Balances
 */
export const useBulkResetAnnualBalances = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkResetAnnualBalances>>, TError,{data: BulkBalanceResetRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof bulkResetAnnualBalances>>,
        TError,
        {data: BulkBalanceResetRequest},
        TContext
      > => {
      return useMutation(getBulkResetAnnualBalancesMutationOptions(options), queryClient);
    }
    /**
 * Search balances with various filters (Admin only)
 * @summary Search Balances
 */
export const searchBalances = (
    params?: SearchBalancesParams,
 signal?: AbortSignal
) => {


      return apiInstance<BalanceListResponse>(
      {url: `/api/balance/search`, method: 'GET',
        params, signal
    },
      );
    }




export const getSearchBalancesQueryKey = (params?: SearchBalancesParams,) => {
    return [
    `/api/balance/search`, ...(params ? [params] : [])
    ] as const;
    }


export const getSearchBalancesQueryOptions = <TData = Awaited<ReturnType<typeof searchBalances>>, TError = HTTPValidationError>(params?: SearchBalancesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchBalances>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchBalancesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchBalances>>> = ({ signal }) => searchBalances(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchBalances>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SearchBalancesQueryResult = NonNullable<Awaited<ReturnType<typeof searchBalances>>>
export type SearchBalancesQueryError = HTTPValidationError


export function useSearchBalances<TData = Awaited<ReturnType<typeof searchBalances>>, TError = HTTPValidationError>(
 params: undefined |  SearchBalancesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchBalances>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchBalances>>,
          TError,
          Awaited<ReturnType<typeof searchBalances>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchBalances<TData = Awaited<ReturnType<typeof searchBalances>>, TError = HTTPValidationError>(
 params?: SearchBalancesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchBalances>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchBalances>>,
          TError,
          Awaited<ReturnType<typeof searchBalances>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchBalances<TData = Awaited<ReturnType<typeof searchBalances>>, TError = HTTPValidationError>(
 params?: SearchBalancesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchBalances>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Search Balances
 */

export function useSearchBalances<TData = Awaited<ReturnType<typeof searchBalances>>, TError = HTTPValidationError>(
 params?: SearchBalancesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchBalances>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchBalancesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Search transactions with various filters (Admin only)
 * @summary Search Transactions
 */
export const searchTransactions = (
    params?: SearchTransactionsParams,
 signal?: AbortSignal
) => {


      return apiInstance<TransactionListResponse>(
      {url: `/api/balance/transactions/search`, method: 'GET',
        params, signal
    },
      );
    }




export const getSearchTransactionsQueryKey = (params?: SearchTransactionsParams,) => {
    return [
    `/api/balance/transactions/search`, ...(params ? [params] : [])
    ] as const;
    }


export const getSearchTransactionsQueryOptions = <TData = Awaited<ReturnType<typeof searchTransactions>>, TError = HTTPValidationError>(params?: SearchTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchTransactions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchTransactionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchTransactions>>> = ({ signal }) => searchTransactions(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchTransactions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SearchTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof searchTransactions>>>
export type SearchTransactionsQueryError = HTTPValidationError


export function useSearchTransactions<TData = Awaited<ReturnType<typeof searchTransactions>>, TError = HTTPValidationError>(
 params: undefined |  SearchTransactionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchTransactions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchTransactions>>,
          TError,
          Awaited<ReturnType<typeof searchTransactions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchTransactions<TData = Awaited<ReturnType<typeof searchTransactions>>, TError = HTTPValidationError>(
 params?: SearchTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchTransactions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchTransactions>>,
          TError,
          Awaited<ReturnType<typeof searchTransactions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchTransactions<TData = Awaited<ReturnType<typeof searchTransactions>>, TError = HTTPValidationError>(
 params?: SearchTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchTransactions>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Search Transactions
 */

export function useSearchTransactions<TData = Awaited<ReturnType<typeof searchTransactions>>, TError = HTTPValidationError>(
 params?: SearchTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchTransactions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchTransactionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






